import { orpc } from "@/utils/orpc.client";

interface CompanyQueryOptionsInput {
  id: string;
  locale: string;
}

export function getCompanyQueryOptions({ id, locale }: CompanyQueryOptionsInput) {
  return orpc.music.getCompany.queryOptions({
    input: { id, locale },
  });
}
